/**
 * All message bundles. Each feature owns one file in ./messages and is registered here.
 * Keys must be globally unique (prefix them with the feature name).
 */
import { auth } from './messages/auth';
import { calendar } from './messages/calendar';
import { choir } from './messages/choir';
import { common } from './messages/common';
import { library } from './messages/library';
import { offline } from './messages/offline';
import { settings } from './messages/settings';
import { viewer } from './messages/viewer';
import { admin } from './messages/admin';
import { annotate } from './messages/annotate';
import { stats } from './messages/stats';
import { sync } from './messages/sync';
import { tabs } from './messages/tabs';
import { practice } from './messages/practice';
import { chat } from './messages/chat';

const bundles = [common, auth, choir, settings, admin, library, viewer, tabs, calendar, offline, annotate, sync, stats, practice, chat] as const;

type Bundle = (typeof bundles)[number];
type UnionToIntersection<U> = (U extends unknown ? (k: U) => void : never) extends (k: infer I) => void ? I : never;
type AllIs = UnionToIntersection<Bundle['is']>;
export type MessageKey = keyof AllIs & string;

function merge(lang: 'is' | 'en') {
  const out: Record<string, unknown> = {};
  for (const b of bundles) {
    for (const [k, v] of Object.entries(b[lang])) {
      if (import.meta.env.DEV && k in out) console.warn(`[i18n] duplicate key ${k}`);
      out[k] = v;
    }
  }
  return out;
}

export const MESSAGES = { is: merge('is'), en: merge('en') } as const;
